import { useEffect, useState } from "react";
import useDataStore from "../../../../../stores/dataStore";

function useAmtOfNotesInFolder(id?: string) {
    const Notes = useDataStore((state) => state.data?.notes);

    // State
    const [notesAMT, setNotesAMT] = useState(0);

    // Get the number of notes in the folder
    useEffect(() => {
        const notes = Object.values(Notes).filter((note) => {
            // If note has no folderID, it will match the props.id
            if (
                note.folderID === id ||
                (note.folderID === undefined && id === "uncategorized")
            ) {
                // Remove invalid notes
                if (!note.id) {
                    useDataStore.getState().remove.note(note.id);
                    return false;
                };

                return true;
            } else {
                return false;
            }
        });

        setNotesAMT(notes.length);
    }, [id, Notes]);

    return notesAMT;
}

export default useAmtOfNotesInFolder;
